import {PhoneNumber, PhoneNumberFormat, PhoneNumberUtil} from 'google-libphonenumber';
import moment from 'moment';
import { RRule } from 'rrule';
const phoneUtil = PhoneNumberUtil.getInstance();

export const parsePhoneNum = (countryCode = '', phoneNumber = ''): PhoneNumber => phoneUtil.parse(`${countryCode}${phoneNumber}`);
export const getTimeSinceDate = (date: Date | string): string => {
  if (!date) {
    return '';
  }
  const intervals = [
    {label: 'year', seconds: 60 * 60 * 24 * 365},
    {label: 'month', seconds: 60 * 60 * 24 * 30},
    {label: 'day', seconds: 60 * 60 * 24},
    {label: 'hour', seconds: 60 * 60},
    {label: 'minute', seconds: 60},
    {label: 'second', seconds: 1},
  ];

  date = date instanceof Date ? date : new Date(date);
  let timeVal = date.getTime();
  if (isNaN(timeVal)) {
    timeVal = new Date().getTime();
  }
  const seconds = Math.floor((Date.now() - timeVal) / 1000) || 1;
  const interval = intervals.find(i => seconds >= i.seconds) || intervals[intervals.length - 1];
  const count = Math.floor(seconds / interval.seconds);
  return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
};

export const formatPhoneNum = (countryCode = '', phoneNumber = ''): string => {
  try {
    return phoneUtil.format(parsePhoneNum(countryCode, phoneNumber), PhoneNumberFormat.INTERNATIONAL);
  } catch (e) {
    return `${countryCode} ${phoneNumber}`;
  }
};

export const parseEmploymentTenure = (employmentTenure: string): {startDate: Date | null; endDate: Date | null} => {
  if (!employmentTenure) {
    return {startDate: null, endDate: null};
  }

  try {
    const rule = RRule.fromString(employmentTenure);
    const startDate = rule.options.dtstart;
    const endDate = rule.options.until || null;

    return {startDate, endDate};
  } catch (error) {
    console.error('Invalid employmentTenure RRule:', employmentTenure, error);
    return {startDate: null, endDate: null};
  }
};

const parseRRule = (rrule: string): {startDate: Date | null; endDate: Date | null} => {
  if (!rrule) {
    return {startDate: null, endDate: null};
  }

  const rules = Object.fromEntries(rrule.split(';').map(rule => rule.split('=')));

  const startDate = rules.DTSTART ? moment(rules.DTSTART, 'YYYYMMDD').toDate() : null;
  const endDate = rules.UNTIL ? moment(rules.UNTIL, 'YYYYMMDD').toDate() : null;

  return {startDate, endDate};
};

export const formatTimelineRange = (rrule: string): string => {
  const {startDate, endDate} = parseRRule(rrule);

  if (!startDate) {
    return '';
  }

  const start = moment(startDate).format('MMM YYYY');
  const end = endDate ? moment(endDate).format('MMM YYYY') : 'Present';

  return `${start} - ${end}`;
};
